//clear cart if cookie not set.
const deleteMyCartCookie = getCookie("deleteMyCart_V2");
async function deleteMyCart() {
  if(!deleteMyCartCookie) {
    const _fetch = await fetch("/cart/clear.js");
    await _fetch.json();
    setCookie("deleteMyCart_V2", true, 1);
    console.log("cart cleared initial");
    window.location.reload();
  }
}

async function saveRestoreLocalCart(method) {
    if (method == "cart_get") {
        const req = await fetch("/cart.js");
        const data = await req.json();
        const items = data.items;
    
        window.localStorage.setItem("loginCartItems", JSON.stringify(items));
        return true;
    }

    if(method == "cart_set") {
        let items = [];
        const cartItems = JSON.parse(window.localStorage.getItem("loginCartItems") || []);
        for(let cartItem of cartItems) {
            items.push( { id: cartItem.id, quantity: cartItem.quantity });
        }

        //set items if there is items
        if(items.length == 0 ) {
            return false;
        }

        await fetch("/cart/clear.js");

        await fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify( {"items": items} )
        });
        window.localStorage.removeItem("loginCartItems");
        return true;
    }
}

// customer register loyalty redirect START
function handleLoyaltyRedirect() {
  const currentUrl = window.location.href;
  const cookieName = "ecom_register_redirect_loyalty";
  const targetRedirectPath = "/account?show=loyalty";

  // Check if the current URL matches the trigger path
  if (currentUrl.includes("/account/register?show=loyalty")) {
    setCookie(cookieName, "true", 1); // Set cookie for 1 hour
    return; // Exit the function
  }

  // Check if the cookie exists
  if (getCookie(cookieName)) {
    deleteCookie(cookieName); // Clear the cookie
    window.location.href = targetRedirectPath; // Redirect to the corrected path
  }
}

handleLoyaltyRedirect();
// customer register loyalty redirect END

class initialScripts {
  #from 
  #action
  
  constructor() {
    //console.log("running in begin started");
    const url_string = window.location.href; 
    const url = new URL(url_string);
    this.#from = url.searchParams.get("from");
    this.#action = url.searchParams.get("action");
    this.#doAction();

    window.addEventListener("DOMContentLoaded", this.afterDomLoad.bind(this), false);
  }

  async #doAction () {
    if(this.#from == "usd" && this.#action == "clear") {
      const clreared = await this.#clearCart();
    }
  }

  async #clearCart () {
    const _fetch = await fetch("/cart/clear.js");
    window.dispatchEvent(new Event("ecomCartClear", { bubbles: true }));
    window.history.replaceState({}, document.title, "/");
  }

  afterDomLoad(e) {
    this.ipGeoLocation(e);
  }

  setCookie(name,value,days) {
      var expires = "";
      if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days*24*60*60*1000));
          expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  }
  
  getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for(var i=0;i < ca.length;i++) {
          var c = ca[i];
          while (c.charAt(0)==' ') c = c.substring(1,c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
      }
      return "";
  }
  
  async ipGeoLocation(e) {
    //console.log("running ip geolocation ");
    const ecomGeoCookie = this.getCookie("ecomGeoCookie");
    const ecomGeo = window.localStorage.getItem("ecomGeoData");
    
    if(ecomGeoCookie !="" && ecomGeo != null) {
      return
    }
    //console.log("No geo cookie. requsting IP geolocation and setting cookie");
    const _fetch = await fetch("https://ipgeolocation.abstractapi.com/v1/?api_key=9213da97f5da48ee924f098af93b618d");//oldAPI d6c82f2b480e4544ad41f936cbba9984
    const result = await _fetch.json();

    this.setCookie("ecomGeoCookie", "true", 1);
    window.localStorage.setItem("ecomGeoData", JSON.stringify(result))

    if(result.country_code != "LK") {
      const isForeignCustomer = await Swal.fire({
        title: 'Are you shopping outside <br> Sri Lanka ?',
        text: 'We value our overseas shoppers. Your contribution helps Sri Lanka during these turbulent time.',
        showDenyButton: true,
        confirmButtonColor: '#3085d6',
        denyButtonColor: '#d33',
        confirmButtonText: "Yes. I'm from outside Sri Lanka",
        denyButtonText:"No",
        allowOutsideClick: false,
          
      })

      //console.log(" country confirm popup", isForeignCustomer);

      //when customer choose yes then show currency poppup
      if(isForeignCustomer.value == true) {
        
        //added below geoRedirectToRemittance cookie req by ustore 2024-04-03
        //console.log("removed redirect based on geolocation req by ustoreTM")
        //this.setCookie("ecomGeoRedirectToRemittance", "true", 1);
        this.setCookie("ecomGeoRedirectToRemittance", "", 0);
        ecomCurrencyChange.showHideCurrencyPopup()
      } 
    } else {
      this.setCookie("ecomGeoRedirectToRemittance", "", 0);
    }
  }
}

window.ecomInitialScripts = new initialScripts();

//listening to checkout click and cart click 
//if selected currency is USD directly redirect to USD site
//if selected currency is not LKR or USD show notice box and redirect to usd cart
//if user come from directly to cart, then check currency and redirect

class bringTocartByCurrency {
  imIn = document.getElementById("im-in").dataset.template;
  remittanceDiv = document.querySelector(`.remittance`);
  timePassed = false;
  delaytime = 7
  redirectLink =""
  
  constructor() {
    // const allCheckoutBtns = document.querySelectorAll(`.checkout_Ncart a, .Floating_cart a`);
    // for(let elem of allCheckoutBtns) {
    //   elem.addEventListener("click", this.checkAndRedirect.bind(this), false);
    // }

    document.addEventListener("click", function(e){

      const target = e.target;
      //console.log(target.classList)
      //console.log(target.classList.contains("normal_checkout"))
      if(target.classList.contains("normal_checkout") || target.classList.contains("Ncheckout_btn")) {
        //console.log("inside checkout check")
        this.checkAndRedirect();
      }
    }.bind(this), false);

    const minicartView = document.querySelector(`.nav-mid-li a[href="/cart"]`);
    if(window.innerWidth < 720) {
      minicartView.addEventListener("click", function(e) {
        e.preventDefault();
        
      })
    }

    document.addEventListener("redirectToRemitance", this.checkAndRedirect.bind(this), false);
    if(this.imIn == "cart") {
      window.addEventListener("ecom-bacurr-loaded", function(){
        const currency = window.localStorage.getItem("choosenCurrency");
        if(currency == "LKR") {
          return
        }
        this.checkAndRedirect()
      }.bind(this), { once: true })
    }
  }

  checkAndRedirect(e) {
    e?.preventDefault()
    const currency = window.localStorage.getItem("choosenCurrency");

    //added below cart redirect req by ustore to remove USD redirection 2024-04-03
    window.location.href = "/cart";
    return
    
    if(currency != "LKR" && currency !="USD") {
      this.remittanceDiv.innerHTML =  
      `
      <h5>Your order will now be processed in USD.</h5>
      <div class="orderProcUsdNotification">
        <img src='https://cdn.shopify.com/s/files/1/0592/3861/3149/files/order-will-place-popup-icon.png?v=1664527236'>
        <p>We appreciate your contribution to Sri Lanka by proceeding in USD during essential times.</p>
      </div>`;
      
      this.remittanceDiv.classList.remove("ecom_hide");
      this.remittanceDiv.style.background = "";
      this.callToRemitanceURL()
      setTimeout(function(){
        this.timePassed = true;
      }.bind(this), this.delaytime * 1000)
      return
    }

    if(currency == "USD") {
      this.remittanceDiv.innerHTML = 
      `<div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
      `;
      this.remittanceDiv.classList.remove("ecom_hide");
      this.remittanceDiv.style.background = " hsl(0deg 0% 0% / 78%)";
      this.callToRemitanceURL();
      setTimeout(function(){
        this.timePassed = true;
      }.bind(this), this.delaytime * 1000)
      return;
    }
    window.location.href = "/cart";
  }

  async callToRemitanceURL () {
    const link = await window.ecomCheckoutObj.redirectToRemittanceSite();
    this.redirectLink = link
    this.canRedirect()
  }

  canRedirect() {
    if(this.redirectLink != "" && this.timePassed) {
      //console.log(this.redirectLink);
       window.location.href = this.redirectLink;
      return
    }
    const myTimeout = setTimeout(function(){
      //console.log("timeout check")
      clearTimeout(myTimeout)
      return this.canRedirect();
    }.bind(this), 100);
  }
}

window.addEventListener("DOMContentLoaded", function(e){
  
  window.bringToCartByCurrencyObj = new bringTocartByCurrency();
})